module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "k-wrap-card"
  }, [_vm._v("\n            Sub Total: "), _c('span', {
    staticClass: "k-tag-red"
  }, [_vm._v(_vm._s(_vm._f("numberFormatted")(_vm.invoiceDues.invoiceDues.totalRemainingFeeOfMonth)))]), _vm._v(" "), _c('Button', {
    staticClass: "btn-refresh",
    attrs: {
      "type": "success",
      "icon": "refresh",
      "size": "small"
    },
    on: {
      "click": _vm.refreshPerMonth
    }
  }, [_c('span', [_vm._v("Refresh")])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.invoiceDues.invoiceDues), function(invoiceDue) {
    return _c('div', {
      key: invoiceDue.id,
      staticClass: "k-wrap-card"
    }, [(invoiceDue[0].invoicedate !== undefined) ? _c('div', _vm._l((invoiceDue), function(invoice) {
      return _c('div', {
        key: invoice.id,
        staticClass: "k-card"
      }, [_c('div', [_c('div', {
        staticClass: "col-1"
      }, [_vm._v(_vm._s(_vm._f("dateFormatted")(invoice.invoicedate)))]), _vm._v(" "), _c('div', {
        staticClass: "col-2"
      }, [_vm._v(_vm._s(invoice.markingheadercode))]), _vm._v(" "), _c('div', {
        staticClass: "col-3"
      }, [_vm._v(_vm._s(invoice.description))]), _vm._v(" "), _c('div', {
        staticClass: "col-4"
      }, [(invoice.invoicedate != '') ? _c('div', [(invoice.notes) ? _c('div', [_c('div', [((invoice.currency === 'SGD' || invoice.currency === 'BAHT') && invoice.currencyvalue <= 1) ? _c('span', {
        staticClass: "k-tag-blue"
      }, [_vm._v(_vm._s(_vm._f("currency")(invoice.remainingFee)) + " (" + _vm._s(_vm._f("numberFormatted")(invoice.remainingFeeIdr)) + ")")]) : _c('span', {
        staticClass: "k-tag-blue"
      }, [_vm._v(_vm._s(_vm._f("numberFormatted")(invoice.remainingFee)))]), _vm._v(" "), (invoice.notes.length != 0) ? _c('div', {
        staticClass: "tooltip"
      }, [_vm._v(_vm._s(invoice.notes.length) + "\n                                            "), _c('span', {
        staticClass: "tooltiptext"
      }, _vm._l((invoice.notes), function(note) {
        return _c('span', [_vm._v("\n                                                    " + _vm._s(_vm._f("notesFormatted")(note)) + " "), _c('br')])
      }), 0)]) : _vm._e()])]) : _c('div', [_c('span', {
        staticClass: "k-tag-blue"
      }, [_vm._v(_vm._s(_vm._f("numberFormatted")(invoice.remainingFee)))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "col-5"
      }, [(invoice.totalRemainingFee != '') ? _c('span', {
        staticClass: "k-tag-green",
        attrs: {
          "type": "border"
        }
      }, [_vm._v(_vm._s(_vm._f("numberFormatted")(invoice.totalRemainingFee)))]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "col-6"
      }, [(invoice.invoicedate != '') ? _c('Input', {
        attrs: {
          "placeholder": "Tambah Keterangan"
        },
        on: {
          "on-change": function($event) {
            return _vm.emitNewNotes(invoice.id, invoice.newNotes)
          }
        },
        model: {
          value: (invoice.newNotes),
          callback: function($$v) {
            _vm.$set(invoice, "newNotes", $$v)
          },
          expression: "invoice.newNotes"
        }
      }) : _vm._e()], 1)])])
    }), 0) : _vm._e(), _c('br')])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31b4f412","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/cInvoiceUnSettledByPeriod.vue
// module id = 1793
// module chunks = 1